import React from "react";
//#region redux
import { useSelector, useDispatch } from "react-redux";
import { AppState } from "store";
import { surveyUpdated } from "store/actions/surveyActions";
//#endregion
//#endregion
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModelSurveys } from "wint-api-client/dist/types";
//#endregion
//#region components
import TopTodoCard from "../../_partials/topTodoCard";
import { TitledContainerInner, EntityCardContent } from "components/common";
import { SurveyTodoButton, useSurveyQuickActions, SurveyTodoFooter, SurveyCommentsList } from "components/survey";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";

const AnnualAccountSurveyTodo: React.FC<TodoCardProps> = (props) => {
  const surveyStatus = props.item.surveyStatus;
  const latestDate = DateHelper.formatDate(props.item.surveyStatus?.lastDateToAnswer!);
  const financialYear = surveyStatus?.description?.slice(-5);
  const selectedCompany = useSelector((state: AppState) => state.auth.selectedCompany.name);
  const dispatch = useDispatch();

  const quickActions = useSurveyQuickActions(surveyStatus?.surveyId ?? "", props.onActionSuccess);

  const reloadSurvey = (comments?: WintSuperkollAPIModelSurveys.SurveyComment[]) => {
    surveyStatus && dispatch(surveyUpdated({ ...surveyStatus, comments: comments }));
  };

  return (
    <EntityCardContent
      topTodoCard={
        <TopTodoCard
          item={props.item}
          descriptionHeadingOne={` ${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Common.FinancialYear
          )} ${financialYear}`}
          descriptionHeadingTwo={selectedCompany}
          footerText={`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Latest)}: ${latestDate}`}
          quickActions={quickActions}
        />
      }
      todoMainSection={
        <TitledContainerInner
          header={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.AnnualAccount.SurveyTodoMainActionHeader
          )}
          subHeader={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.AnnualAccount.SurveyTodoMainActionDescription
          )}
        >
          <SurveyTodoButton surveyStatus={surveyStatus!} />
        </TitledContainerInner>
      }
      footer={<SurveyTodoFooter id={surveyStatus?.surveyId ?? ""} markAsDoneHandler={props.onActionSuccess} />}
    >
      <SurveyCommentsList
        surveyId={surveyStatus?.surveyId ?? ""}
        comments={surveyStatus?.comments}
        reloadSurvey={reloadSurvey}
      />
    </EntityCardContent>
  );
};

export default AnnualAccountSurveyTodo;
